import { ResolverTag } from '@ps/web-core-enums';
import { integrationTesting } from '@ps/web-core-utils';
import type { Reference } from '@ps/web-martech-cms-types';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';

import { CMSContainer, CMSHTML, CMSPageSection, PageBody } from '@swf/cms';
import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import useDebouncedSelector from '@swf/core/hooks/useDebouncedSelector';
import { select } from '@swf/core/store';

import {
  TXTWCL_Missing_Page,
  TXTWCL_Please_let_us_know_about_the_p_ELL_1,
  TXTWCL_WeXre_sorryX_but_you_have_reac_ELL
} from './NotFoundBody.messages.json';
import styles from './NotFoundBody.scss';

const emptyReferences: Reference[] = [];

const NotFoundBody: React.FC = () => {
  const { formatMessage } = useIntl();
  const loading = useDebouncedSelector(select.cms.getPageLoading, integrationTesting ? 1000 : 0);

  return (
    <>
      <div className={classNames(styles.topContainer, styles.bgStyle3)}>
        {!loading && <div className={styles.banner} />}
      </div>
      <PageBody twoColumns={false} darkTheme={false} main={emptyReferences} side={emptyReferences}>
        <CMSContainer
          container={{
            variant: 'bgStyle2',
            reference: [],
            visibility_rules: [],
            dynamic_background: {}
          }}
        >
          <CMSPageSection
            heading={{
              level: 'h2',
              title: formatMessage(TXTWCL_Missing_Page),
              hero: false,
              alignment: 'center'
            }}
            className={styles.center}
          >
            <CMSHTML tag="p" content={formatMessage(TXTWCL_WeXre_sorryX_but_you_have_reac_ELL)} />
            <Translation
              values={{
                a: (msg: React.ReactNode) => (
                  <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
                )
              }}
              {...TXTWCL_Please_let_us_know_about_the_p_ELL_1}
            >
              {(message) => <p>{message}</p>}
            </Translation>
          </CMSPageSection>
        </CMSContainer>
      </PageBody>
    </>
  );
};

export default NotFoundBody;
